<script>
	const Q = require('q');
	const utilities = require('utilities');
	const assignmentService = require('services/assignmentService');
	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const SHOW_RESULTS_DISMISS = accountSettingsUtilities.settings.SHOW_RESULTS_DISMISS;

	const { beginAssignmentAction, endAssignmentAction } = require('utilities/assignmentUtilities');

	module.exports = {
		components: {
			modal: require('./modal.vue').default
		},
		data() {
			return {
				assignment: {},
				showResultsDimiss: null,
				loading: false
			};
		},
		mounted() {
			this.checkSetting();

			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-show-results') {
					return true; // let some other handler take this
				}
				let prms = Q();
				this.loading = true;

				beginAssignmentAction();

				if (opts) {
					this.assignment = opts.assignment;
				} else {
					return false;
				}

				if (typeof this.showResultsDimiss !== 'boolean') {
					prms = this.checkSetting();
				}

				prms
					.then(() => this.toggleResults(this.assignment))
					.finally(() => {
						if (this.showResultsDimiss) {
							this.closeModals();
						}
						this.loading = false;
						endAssignmentAction();
					});
				return false;
			});

			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-show-results') {
					return true; // let some other handler take this
				}
				this.assignment = {};
				return false;
			});
		},
		methods: {
			closeModals() {
				utilities.closeModals();
			},
			dismissShowResultsModal() {
				accountSettingsUtilities.update(SHOW_RESULTS_DISMISS, true);
				this.showResultsDimiss = true;
				this.closeModals();
			},
			checkSetting() {
				return accountSettingsUtilities.read(SHOW_RESULTS_DISMISS).then(value => {
					let v = !!value;
					this.showResultsDimiss = v;
					return v;
				});
			},
			toggleResults(assignment) {
				let params = {
					assignmentId: assignment.assignmentId,
					classCode: assignment.classCode,
					assignmentStatus: assignment.assignmentStatus,
					shwres: assignment.showResults === false
				};

				return assignmentService.teacherUpdateAssignment(params);
			}
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-show-results"
		:loading="loading"
		:ok="false"
		:closeable="false"
		:no-auto-close="true">
		<div slot="header-container">
			<h2 v-if="assignment.showResults !== false">Results hidden from students</h2>
			<h2 v-if="assignment.showResults === false">Results shared with students</h2>
		</div>
		<div
			class="modal-content-main -centered"
			slot="content">
			<h3 v-if="assignment.showResults === false">Students will now be able to view their assignments results.</h3>
			<h3 v-if="assignment.showResults !== false">Students will no longer be able to view their assignments results.</h3>
			<p>
				<button
					class="button -outline"
					@click="closeModals">
					Ok
				</button>
			</p>
			<button
				class="button -link -link-muted dismiss font-small"
				@click="dismissShowResultsModal">
				Don't show this message again.
			</button>
		</div>
	</modal>
</template>
